// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as NLOrderCommentsVm from "../vm-mapper/NLOrderCommentsVm.bs.js";
import * as NLOrderCommentsForm from "./NLOrderCommentsForm.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as NLOrderFetchCommentsStateMachine from "./NLOrderFetchCommentsStateMachine.bs.js";
import * as FixedLoadingViewComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/FixedLoadingViewComponent.bs.js";

function NLOrderCommentsSection$CommentsList(Props) {
  var comments = Props.comments;
  var comments$1 = NLOrderCommentsVm.getVm(comments);
  return React.createElement("div", {
              className: "c-comments-list"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.map((function (param) {
                        return React.createElement("div", {
                                    className: "comment"
                                  }, React.createElement(Row$Catalyst.make, {
                                        children: null,
                                        className: "title-section"
                                      }, React.createElement("div", {
                                            className: "commenter"
                                          }, param.commenter), React.createElement("div", {
                                            className: "time"
                                          }, param.created_at)), React.createElement("div", {
                                        className: "comment-description"
                                      }, param.comment));
                      }), comments$1)));
}

var CommentsList = {
  make: NLOrderCommentsSection$CommentsList
};

function NLOrderCommentsSection(Props) {
  var user = Props.user;
  var order_crn = Props.order_crn;
  var order_id = Props.order_id;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useReducer(NLOrderFetchCommentsStateMachine.reducer, {
        TAG: /* Loading */0,
        _0: undefined
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  React.useEffect((function () {
          NLOrderFetchCommentsStateMachine.fetchComments(order_crn, dispatch)(country);
          
        }), []);
  var tmp;
  switch (state.TAG | 0) {
    case /* Loading */0 :
        var comments = state._0;
        tmp = comments !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(NLOrderCommentsSection$CommentsList, {
                    comments: comments
                  }), React.createElement(FixedLoadingViewComponent$Catalyst.make, {})) : React.createElement(FixedLoadingViewComponent$Catalyst.make, {});
        break;
    case /* Live */1 :
        tmp = React.createElement(NLOrderCommentsSection$CommentsList, {
              comments: state._0
            });
        break;
    case /* Error */2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: state._0
            });
        break;
    
  }
  return React.createElement("div", {
              className: "c-comments-section"
            }, React.createElement(NLOrderCommentsForm.make, {
                  user: user,
                  order_id: order_id,
                  refetch_comments: (function (param) {
                      Curry._1(dispatch, /* SetLoading */0);
                      return NLOrderFetchCommentsStateMachine.fetchComments(order_crn, dispatch)(country);
                    })
                }), tmp);
}

var make = NLOrderCommentsSection;

export {
  CommentsList ,
  make ,
  
}
/* react Not a pure module */
